export const date = () => new Date().toLocaleDateString().split('/')[0];